<template lang="pug">
  .modal.modal--sm
    button.modal__close(
    @click="$emit('close')"
    )
      img(src="@/assets/images/icons/cross.svg")
    h2.modal__title Подача заявки
    p.modal__text Перед подачей заявки необходимо заполнить&#32;
      a.main-color(
      href=""
      @click.prevent="$router.push({name: 'user-profile'})"
      ) профиль
      | .
    .modal__button
      button.button.button_paint-main.button_full(
      @click.prevent="$router.push({name: 'user-profile'})"
      )
        .button__text Заполнить профиль
</template>
<script>
export default {
  name: "check-profile",
  data() {
    return {};
  },
};
</script>
